import { Injectable } from '@angular/core';
import { EndPointService } from 'src/app/core/services/end-point.service';
import { Observable, switchMap } from 'rxjs';
import { EmployeeService } from 'src/app/shared/personnel-files/services/employee.service';
import { ICompanyObjectiveSettings } from '../../performance-objectives/models/CompanyObjectiveSettings';
import { IObjectiveListResponse, IObjective, ObjectiveStatus, ObjectiveComment } from '../../performance-objectives/models/Objective';
import { ObjectiveCategory } from '../../performance-objectives/models/ObjectiveCategory';
import { ObjectiveDomain } from '../../performance-objectives/models/ObjectiveDomain';
import { ObjectiveType } from '../../performance-objectives/models/ObjectiveType';
import { DevelopmentObjective, DevelopmentObjectiveComment, EmployeeContractWrapper } from '../models/DevelopmentObjective';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class DevelopmentObjectiveService {

  private _baseUrl = '/api/reviews/objective/';

  constructor(
    private _endPoints: EndPointService,
    private _employeeService: EmployeeService,
    private http: HttpClient
  ) {
    this.registerEndPoints();
  }

  private registerEndPoints(): void {
    this._endPoints.registerEndPoint<ICompanyObjectiveSettings>('devobjective_get_settings', `${this._baseUrl}settings`, true);
    this._endPoints.registerEndPoint<void>('devobjective_save_rights', `${this._baseUrl}savedevrights`, false);

    this._endPoints.registerEndPoint<number>('devobjective_add', `${this._baseUrl}adddevgoal`, false);
    this._endPoints.registerEndPoint<void>('devobjective_update', `${this._baseUrl}updatedevgoal`, false);
    this._endPoints.registerEndPoint<void>('devobjective_delete', `${this._baseUrl}deletedevgoal`, false);
    this._endPoints.registerEndPoint<DevelopmentObjectiveComment[]>('devdevobjective_get_comments', `${this._baseUrl}devcomments`, false);
    this._endPoints.registerEndPoint<number>('devobjective_add_comment', `${this._baseUrl}adddevcomment`, false);
    this._endPoints.registerEndPoint<void>('devobjective_delete_comment', `${this._baseUrl}deletedevcomment`, false);
  }

  public getSettings(studentId?: number, fetch?: boolean): Observable<ICompanyObjectiveSettings> {
    return this._endPoints.call<ICompanyObjectiveSettings>('devobjective_get_settings', { studentId: studentId || 0 }, fetch);
  }

  public saveRights(allowDevelopmentGoalsCreate: boolean, allowDevelopmentGoalsEdit: boolean, allowDevelopmentGoalsDelete: boolean, studentId: number) {
    return this._endPoints.call<void>('devobjective_save_rights', { studentId, create: allowDevelopmentGoalsCreate, edit: allowDevelopmentGoalsEdit, delete: allowDevelopmentGoalsDelete });
  }

  // dev goals
  public getDevGoals(studentId: number, forCompletedConversation?: number): Observable<EmployeeContractWrapper[]> {
    return this.http.post<EmployeeContractWrapper[]>(`${this._baseUrl}devgoals`, { studentId, forCompletedConversation });
  }

  public addDevGoal(objective: DevelopmentObjective): Observable<number> {
    return this._endPoints.call<number>('devobjective_add', objective);
  }

  public updateDevGoal(objective: DevelopmentObjective): Observable<void> {
    return this._endPoints.call<void>('devobjective_update', objective);
  }

  public deleteDevGoal(objectiveId: number): Observable<void> {
    return this._endPoints.call<void>('devobjective_delete', { objectiveId });
  }


  // dev goal comments
  public getDevComments(objectiveId: number): Observable<DevelopmentObjectiveComment[]> {
    return this._endPoints.call<DevelopmentObjectiveComment[]>('devdevobjective_get_comments', { objectiveId });
  }

  public addDevComment(comment: DevelopmentObjectiveComment): Observable<number> {
    return this._endPoints.call<number>('devobjective_add_comment', comment);
  }

  public deleteDevComment(commentId: number): Observable<void> {
    return this._endPoints.call<void>('devobjective_delete_comment', { commentId });
  }
}
